// ABOUTME: Confirmation dialog for canceling a pending family invitation
// ABOUTME: Shows invitation details and confirms cancellation

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography
} from '@mui/material';
import type { PendingInvitation } from '../types';

interface CancelInvitationDialogProps {
  open: boolean;
  invitation: PendingInvitation | null;
  canceling: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const CancelInvitationDialog: React.FC<CancelInvitationDialogProps> = ({
  open,
  invitation,
  canceling,
  onClose,
  onConfirm
}) => {
  if (!invitation) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      data-testid="cancel-invitation-confirmation"
    >
      <DialogTitle>Cancel Invitation</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to cancel the invitation for{' '}
          <strong>
            {invitation.firstName} {invitation.lastName}
          </strong>{' '}
          ({invitation.email})?
        </Typography>
        <Typography sx={{ mt: 2, color: 'text.secondary' }}>
          This action cannot be undone. You can send a new invitation later if needed.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={canceling}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={canceling}
        >
          {canceling ? <CircularProgress size={24} /> : 'Confirm Cancel'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelInvitationDialog;
